import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">漫画分类</h2>
          <p className="mt-2 text-sm text-foreground-600">探索你喜欢的漫画类型，发现更多精彩内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 transition-all border border-background-200/70 hover:border-primary-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all mb-3">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="font-heading text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 mt-1">{cat.count}部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}